import { Link } from "react-router-dom";
import "../styles/Footer.css";

export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <h3 className="brand-name">The Golden Moon</h3>
            <p className="brand-tagline">Élégance noire & or</p>
            <p className="brand-description">
              Cadres personnalisés noir et or, pensés pour transformer vos souvenirs en cadeaux élégants. Chaque pièce raconte une histoire unique.
            </p>
          </div>
          
          {/* Navigation */}
          <div className="footer-links-section">
            <h5 className="footer-heading">Navigation</h5>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/collection">Collection</Link></li>
              <li><Link to="/a-propos">À propos</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>
          
          {/* Commande */}
          <div className="footer-links-section">
            <h5 className="footer-heading">Commande</h5>
            <ul className="footer-links commande-links">
              <li><span className="link-icon">✓</span> Paiement à la livraison</li>
              <li><span className="link-icon">✓</span> Livraison fixe : 8 DT</li>
              <li>
                <a href="https://wa.me/21693964241" target="_blank" rel="noopener noreferrer">
                  <span className="link-icon">📱</span> WhatsApp : +216 93 964 241
                </a>
              </li>
            </ul>
          </div>
          
          {/* Follow Us */}
          <div className="footer-social">
            <h5 className="footer-heading">Suivez-nous</h5>
            
            <div className="social-icons">
              <a href="https://www.facebook.com/thegoldenmoontn" className="social-link" target="_blank" rel="noopener noreferrer">
                <div className="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="16" height="16">
                    <path fill="currentColor" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
                  </svg>
                </div>
                <span>Facebook</span>
              </a>
              
              <a href="https://www.instagram.com/__thegoldenmoon/" className="social-link" target="_blank" rel="noopener noreferrer">
                <div className="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16">
                    <path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8z"/>
                  </svg>
                </div>
                <span>Instagram</span>
              </a>
              
              <a href="https://www.tiktok.com/@thegoldenmoonn" className="social-link" target="_blank" rel="noopener noreferrer">
                <div className="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16">
                    <path fill="currentColor" d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/>
                  </svg>
                </div>
                <span>TikTok</span>
              </a>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="copyright">© 2026 The Golden Moon — Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
}